import { NormalizedRoute } from './route-types'

export function formatTime(totalMins: number): string {
  let time = ''
  const days = Math.floor(totalMins / 1440)
  if (days) {
    time += days + 'd '
    totalMins = totalMins % 1440
  }
  const hours = Math.floor(totalMins / 60)
  if (hours) {
    time += hours + 'h '
    totalMins = totalMins % 60
  }
  time += totalMins + (time ? 'm' : totalMins === 1 ? ' min' : ' mins')
  return time
}

export function getRouteTimeMinutes(route: NormalizedRoute): number {
  return Math.round(route.durationSeconds / 60)
}

export function getNormalTimeMinutes(route: NormalizedRoute): number {
  return Math.round(route.staticDurationSeconds / 60)
}

export function showNormalTime(route: NormalizedRoute): boolean {
  return route.durationSeconds > 0 && route.staticDurationSeconds > 0
}

export function formatComparativeTime(route: NormalizedRoute): string {
  const currentMins = getRouteTimeMinutes(route)
  const normalMins = getNormalTimeMinutes(route)
  if (!showNormalTime(route)) return ''
  const diff = currentMins - normalMins
  if (diff > 0) {
    return Math.abs(diff) + ' min slower than normal'
  } else if (diff < 0) {
    return Math.abs(diff) + ' min faster than normal'
  }
  return ''
}
